const externalSource = ['QUOTEZONE', 'MSE', 'FACEBOOK'] as const;
export type ExternalSource = (typeof externalSource)[number];

export function isExternalSource(maybeExternalSource: string | null): maybeExternalSource is ExternalSource {
  return externalSource.some((realSource) => maybeExternalSource === realSource);
}
